/**
 * Contentsquare session replay URL on the Conversation klass in Kustomer.
 * Create in Settings > Platform > Klasses > Conversation as type URL.
 * Kustomer auto-generates the system name with a Url suffix.
 */
export const KUSTOMER_CSQ_REPLAY_LINK_ATTR = 'contentsquareReplayLinkUrl';
/**
 * Session-scoped Sentry id on the Conversation klass in Kustomer.
 * Create in Settings > Platform > Klasses > Conversation as type Text,
 * display name "Sentry Session ID". Kustomer generates the system name with a Str suffix.
 * Search Sentry issues with `utk_sentry_sid:<value>`.
 */
export const KUSTOMER_SENTRY_SESSION_ID_ATTR = 'sentrySessionIdStr';
/** Contentsquare custom page event fired when a Kustomer chat conversation is created. */
export const CSQ_KUSTOMER_CHAT_STARTED_EVENT = 'kustomer_chat_started';
/** Contentsquare dynamic variable keys for Kustomer conversation metadata. */
export const CSQ_KUSTOMER_CONVERSATION_ID_VAR = 'kustomer_conversation_id';
export const CSQ_KUSTOMER_CONVERSATION_URL_VAR = 'kustomer_conversation_url';
/** @see https://support.kustomer.com/en_us/search-by-url-HksTVii1U */
export function buildKustomerConversationUrl(orgSlug, conversationId) {
    return `https://${orgSlug}.kustomerapp.com/app/conversations/${conversationId}`;
}
